import archivesService from '@/services/archives.service'

import { ArchivesActionTypes } from './action_types'
import { ArchivesMutationTypes } from './mutation_types'
import { ArchivesState } from './state'

export const actions: StoreActions<ArchivesActionTypes, ArchivesMutationTypes> = {
  async [ArchivesActionTypes.GET_SEARCH_ARCHIVES] ({ commit }, { search, params }) {
    commit(ArchivesMutationTypes.SET_LIST_SEARCH_PENDING, true)
    try {
      const { data } = await archivesService.searchArchives(search, params)
      commit(ArchivesMutationTypes.SET_LIST_SEARCH_DATA, data.data)
      commit(ArchivesMutationTypes.SET_LIST_SEARCH_DATA_COUNT, data.pagination.itemCount)
    } finally {
      commit(ArchivesMutationTypes.SET_LIST_SEARCH_PENDING, false)
    }
  },
  async [ArchivesActionTypes.GET_ARCHIVE_CONFIG] ({ commit, state }) {
    let config = (state as ArchivesState).config
    if (!config) {
      commit(ArchivesMutationTypes.SET_CONFIG_PENDING, true)
      const { data } = await archivesService.getConfig()
      config = data
      commit(ArchivesMutationTypes.SET_CONFIG_PENDING, false)
    }
    commit(ArchivesMutationTypes.SET_CONFIG, config)
  },
  async [ArchivesActionTypes.GET_ARCHIVE_RIGHTS] ({ commit }, archiveId) {
    commit(ArchivesMutationTypes.SET_GET_ARCHIVE_RIGHTS_PENDING, true)
    const { data } = await archivesService.getArchiveRights(archiveId)
    commit(ArchivesMutationTypes.SET_GET_ARCHIVE_RIGHTS_PENDING, false)
    commit(ArchivesMutationTypes.SET_CURRENT_ARCHIVE_RIGHTS, data)
  },
  async [ArchivesActionTypes.SHARE_ARCHIVES] ({ commit }, file) {
    commit(ArchivesMutationTypes.SET_SHARE_ARCHIVES_PENDING, true)
    await archivesService.shareArchives(file)
    commit(ArchivesMutationTypes.SET_SHARE_ARCHIVES_PENDING, false)
  },
  async [ArchivesActionTypes.UPLOAD_ARCHIVE] ({ commit, state }, file) {
    // We don't actually have any id for files not yet uploaded
    // so we generate a unique one from the currently pending array
    const id = (state as ArchivesState).uploadArchivePendingIds.length + 1
    commit(ArchivesMutationTypes.ADD_UPLOAD_ARCHIVE_PENDING, id)
    try {
      await archivesService.postArchive(file)
      file.status = 'success'
    } catch (error) {
      commit(ArchivesMutationTypes.ADD_UPLOAD_ARCHIVE_ERROR, error)
      file.status = 'error'
    } finally {
      commit(ArchivesMutationTypes.REMOVE_UPLOAD_ARCHIVE_PENDING,
        (state as ArchivesState).uploadArchivePendingIds.indexOf(id),
      )
    }
  },
  async [ArchivesActionTypes.POST_ARCHIVE] ({ commit, state }, file) {
    commit(ArchivesMutationTypes.ADD_POST_ARCHIVE_PENDING, file.id)
    try {
      await archivesService.postArchive(file)
      file.status = 'success'
    } catch (error) {
      file.status = 'error'
      commit(ArchivesMutationTypes.ADD_POST_ARCHIVE_ERROR, error)
    } finally {
      commit(ArchivesMutationTypes.REMOVE_POST_ARCHIVE_PENDING,
        (state as ArchivesState).postArchivePendingIds.indexOf(file.id),
      )
    }
  },
  [ArchivesActionTypes.SELECT_DOCUMENTS] ({ commit }, selectedDocuments) {
    commit(ArchivesMutationTypes.SET_SELECTED_DOCUMENTS, selectedDocuments)
  },
  [ArchivesActionTypes.DESELECT_ALL_DOCUMENTS] ({ commit }) {
    commit(ArchivesMutationTypes.SET_SELECTED_DOCUMENTS, [])
  },
  async [ArchivesActionTypes.GET_ARCHIVES_DOWNLOAD] ({ commit }, { params }) {
    commit(ArchivesMutationTypes.SET_ARCHIVES_DOWNLOAD_PENDING, true)
    try {
      const { data } = await archivesService.getArchivesDownload({ params })
      return data
    } finally {
      commit(ArchivesMutationTypes.SET_ARCHIVES_DOWNLOAD_PENDING, false)
    }
  },
  async [ArchivesActionTypes.SEND_ARCHIVES] ({ commit }, { params }) {
    commit(ArchivesMutationTypes.SET_SEND_ARCHIVES_PENDING, true)
    try {
      await archivesService.sendArchives(params)
    } finally {
      commit(ArchivesMutationTypes.SET_SEND_ARCHIVES_PENDING, false)
    }
  },
}
